import React, { useState, useEffect } from "react";
import Box from '@mui/material/Box';
import { DataGrid } from '@mui/x-data-grid';
import { makeStyles } from '@mui/styles';
import Stack from "@mui/material/Stack";
import Pagination from "@mui/material/Pagination";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import { Button } from "@mui/material";
import AddNewMemberModal from "./AddNewMemberModal";
import TextField from "@mui/material/TextField";
import SearchIcon from "@material-ui/icons/Search";
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import axios from 'axios';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import { getUserMaintenanceList } from '../function-components/Redux/ProjectMasterSlice';
import { useDispatch, useSelector } from "react-redux";
import { useMsal } from "@azure/msal-react";

const baseURL = "https://atcilkm.listracker.accenture.com/listracker-apis";
//const baseURL = "http://localhost:1101";

const UserMaintenance = () => {
  const [searchVal, setSearchVal] = useState("");
  const [statusRefresh, setStatusRefresh] = useState(false);
  const [snackbar, setSnackbar] = useState(null);
  const handleCloseSnackbar = () => setSnackbar(null);
  const dispatch = useDispatch();
  const userMaintenanceList = useSelector((state) => state.projectMaster.userMaintenanceList);
  const [page, setPage] = useState(1);
  const PER_PAGE = 6;
  const startIdx = (page - 1) * PER_PAGE;
  const endIdx = startIdx + PER_PAGE;
  const currentItems = userMaintenanceList.slice(startIdx, endIdx);
  const count = Math.ceil(userMaintenanceList.length / PER_PAGE);
  const [refreshTable, setRefreshTable] = useState(false);
  const [action, setAction] = useState('');


  const readOnlyUsers = [
    "aluru.akash",
    "manoj.kumar.swain",
    "vinay.a.kumar.dubey",
    "shramika.s.ambolkar",
    "reshmi.haridas.m",
    "j.b.bhardwaj",
    "aayushi.bharti",
    "medha.sundriyal",
    "manasa.h.n",
    "d.kumari.vaishnava",
    "lavanya.umesh",
    "akshata.bhau.malvi"
   ];

   const AdminUsers = [
    "h.srinivasan",
    "varsha.a.tyagi",
    "jeevadharani.ramanan",
    "arpita.m.singh",
    "ankur.e.mishra",
    "uma.rani.battu",
    "d.d.choudhary"
   ];
   const { instance } = useMsal();
   const activeAccount = instance.getActiveAccount();
   let loggedInEnterpriseId = "";
   if (activeAccount) loggedInEnterpriseId = activeAccount.idTokenClaims.enterpriseID;

  const searchFunction = (e) => {
    setSearchVal(e.target.value);
  };

  const [filteredData, setFilteredData] = useState([]);

  useEffect(() => {
    setFilteredData(userMaintenanceList);
  }, [userMaintenanceList]);

  useEffect(() => {

    setFilteredData(
      userMaintenanceList?.filter((item) =>
        Object.keys(item).some((key) =>
          item["username"].toLowerCase().includes(searchVal.toLowerCase())
        )
      )
    );
    // setFilteredDome(true);
  }, [searchVal]);

  const handleChange = (e, p) => {
    setPage(p);
  };
  const theme = createTheme({
    typography: {
      fontFamily: "Graphik-Regular",
    },
    components: {
      MuiInput: {
        styleOverrides: {
          underline: {
            '&:hover:not(.Mui-disabled):before': {
              borderBottom: 'none !important',
            },
            '&.Mui-focused:after': {
              borderBottom: 'none !important',
            },
          },
        },
      },
    },
  });


  const useStyles = makeStyles({
    idCell: {
      color: '#7500C0',
    },
    centeredCell: {
      display: 'flex !important',
      justifyContent: 'center !important',
      alignItems: 'center !important',
    },
    root: {
      '& .MuiDataGrid-cell': {
        border: 'none !important'
      },
      '& .MuiDataGrid-columnHeader': {
        borderBottom: 'none !important'
      }
    },
    enterpriseIdCell: {
      color: '#460073',
      fontWeight: 'bold'
    }
  });

  const classes = useStyles();

  function StatusDropdown(props) {
    const { initialValue, onChange } = props;
    const [status, setStatus] = useState(initialValue);


    const getColorForStatus = (statusValue) => {
      switch (statusValue) {
        case 'Available':
          return '#108501';
        case 'Occupied':
          return '#FF3246';
        default:
          return 'black'; // Default color
      }
    };


    const handleStatusChange = (e) => {
      const newStatus = e.target.value;
      setStatus(newStatus);
      setStatusRefresh(!statusRefresh)
      if (onChange) {
        onChange(newStatus);
      }
    }

    return (
      <Select value={status} onChange={handleStatusChange} className="status_dropDown" style={{ color: getColorForStatus(status) }}>
        <MenuItem sx={{ fontSize: "14px !important" }} value={"Available"}>Available</MenuItem>
        <MenuItem sx={{ fontSize: "14px !important" }} value={"Occupied"}>Occupied</MenuItem>
      </Select>
    );
  }

  const columns = [
    { field: 'SerialNo', headerName: 'SL.#', flex: 0.5 },
    {
      field: 'username',
      headerName: 'Enterprise ID',
      flex: 1,
      editable: false,
      cellClassName: classes.enterpriseIdCell,
    },
    {
      field: 'team',
      headerName: 'Team',
      flex: 1,
      editable: false,
    },
    {
      field: 'status',
      headerName: 'Status',
      flex: 1,
      editable: false,
      renderCell: (params) => {
        const isReadOnly = readOnlyUsers.includes(loggedInEnterpriseId);
        const textColor = params.value === 'Occupied' ? '#FF3246' : params.value === 'Available' ? '#108501' : 'black';
          return isReadOnly ? (
            // Render a non-editable text for non-editable cells
            <div style={{ color: textColor }}>{params.value}</div>
          ) : (
          <StatusDropdown
          readOnly={readOnlyUsers.includes(loggedInEnterpriseId)}
            initialValue={params.value}
            onChange={(newStatus) => {
              const status = newStatus;
              axios.put(`${baseURL}/editUserMaintenanceData/${params.id}`, {
                status
              })
                .then((res) => {
                  console.log(res.data)
                  setSnackbar({ children: 'Data successfully saved', severity: 'success' });
                  setRefreshTable(!refreshTable)
                })
                .catch((err) => {
                  console.log(err)
                })
            }}
          />
          );
      },
    },
    {
      field: 'action',
      headerName: 'Active/Inactive',
      flex: 1,
      editable: false,
      renderCell: (params) => {
        const isReadOnly = readOnlyUsers.includes(loggedInEnterpriseId);
    
        return (
          <div style={{ width: 210, margin: 'auto', textAlign: 'center !important' }}>
            {isReadOnly ? (
              // Render a non-editable image for non-editable cells
              <img
                src={params.value === 'Active' ? '/images/projectMaster/active.png' : '/images/projectMaster/inactive.png'}
                alt={params.value}
                style={{ width: 30, height: 15, margin: 'auto !important' }}
              />
            ) : (
              // Render the editable image for editable cells
              <img
                src={params.value === 'Active' ? '/images/projectMaster/active.png' : '/images/projectMaster/inactive.png'}
                alt={params.value}
                style={{ width: 30, height: 15, margin: 'auto !important', cursor: 'pointer' }}
                onClick={() => {
                  const newAction = params.value === 'Active' ? 'Inactive' : 'Active';
                  axios
                    .put(`${baseURL}/editUserMaintenanceData/${params.id}`, { action: newAction })
                    .then((res) => {
                      console.log(res.data);
                      setSnackbar({ children: 'Data successfully saved', severity: 'success' });
                      setRefreshTable(!refreshTable);
                    })
                    .catch((err) => {
                      console.log(err);
                    });
                }}
              />
            )}
          </div>
        );
       }
    },
  ]

  const rows = filteredData != undefined &&
    filteredData.length != 0 &&
    filteredData.slice(startIdx, endIdx)
      .map((data, i) => ({ ...data, SerialNo: startIdx + i + 1 }));

  useEffect(() => {
    dispatch(getUserMaintenanceList());
  }, [refreshTable, statusRefresh]);


  return (
    <>
      <ThemeProvider theme={theme}>
        <Box sx={{ width: "93.5%", margin: "auto", paddingTop: "30px", paddingBottom: "10px", display: "flex", justifyContent: "space-between" }}>
          <Typography sx={{ fontWeight: "bold", fontSize: "24px" }}>User Maintenance</Typography>
          { AdminUsers.includes(loggedInEnterpriseId) ? (
          <Button className="addNewProject_button">
            <AddNewMemberModal />
          </Button>
          ) : null }
        </Box>
        <Box sx={{ height: 380, width: '93.5%', margin: 'auto' }}>
          <div className="searchBox">
            <div className="search_icon">
              <SearchIcon />
            </div>
            <TextField
              id="standard-search"
              label="Search..."
              type="search"
              variant="standard"
              value={searchVal}
              onChange={searchFunction}
            />
          </div>
          <div style={{width: '100%'}}>
          <DataGrid className='projectControlTable'
            rows={rows}
            columns={columns}
            initialState={{
              pagination: {
                paginationModel: {
                  pageSize: 6,
                },
              },
            }}
            pageSizeOptions={[6]}
            checkboxSelection={false}
            disableRowSelectionOnClick
            disableColumnSelector={true}
            hideFooterPagination
          />
          </div>
          {!!snackbar && (
            <Snackbar
              open
              anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
              onClose={handleCloseSnackbar}
              autoHideDuration={3000}
            >
              <Alert {...snackbar} onClose={handleCloseSnackbar} />
            </Snackbar>
          )}
          <Stack className="pagination_stack_projectstatus">
            <Pagination count={count} page={page} onChange={handleChange} color="secondary" />
          </Stack>
        </Box>
      </ThemeProvider>
    </>
  )
}

export default UserMaintenance;